var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"btn-icon-text",staticStyle:{"white-space":"nowrap"},attrs:{"variant":"success"},on:{"click":_vm.addBox}},[_c('i',{staticClass:"mdi mdi-server-plus btn-icon-prepend m-0"}),(!_vm.light)?_c('span',[_vm._v(_vm._s(_vm.$t('header.buttons.addBox')))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }